import { JsonapiEntity, attribute, entity } from 'jsonapi-transformers';

export enum DigitisationStatus {
  LIVE = 'LIVE',
  PENDING = 'PENDING',
  REFERRED = 'REFERRED',
  REJECTED = 'REJECTED',
  WITHDRAWN = 'WITHDRAWN',
  EXPIRED = 'EXPIRED',
  NONE = 'NONE',
}

@entity({ type: 'content' })
export class DigitisedContent extends JsonapiEntity<DigitisedContent> {
  @attribute() request_id: string;
  @attribute() status: DigitisationStatus;
  @attribute() bundle_available?: boolean;
  @attribute() bundle_id?: string;
  @attribute() link?: string;
  @attribute() external_link?: string;
  @attribute() start_date?: string;
  @attribute() end_date?: string;
}
